// Upload.js
import React, { useState } from 'react';
import axios from 'axios';
import logo from './img/edaplogo.png';
import './upload.css';

function Upload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [downloadLink, setDownloadLink] = useState('');
  const [matricule, setMatricule] = useState('');

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleMatriculeChange = (e) => {
    setMatricule(e.target.value);
  };

  const handleFileUpload = async () => {
    if (!selectedFile || !matricule) {
      setUploadStatus('Please enter matricule and select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('matricule', matricule); // Include matricule in the form data

    try {
      setUploadStatus('Uploading...');
      const response = await axios.post('http://localhost:5000/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setUploadStatus('Upload successful!');
      setDownloadLink(`http://localhost:5000/download/${response.data.filename}`);
    } catch (err) {
      setUploadStatus('Upload failed.');
    }
  };

  return (
    <div className='uploaDoc'>
        <img src={logo} alt="logo" />
        <div className="uplo-form">
            <input type="text" className='upinput' value={matricule} onChange={handleMatriculeChange} placeholder="Entre le Matricule" /> <br/>
            <div className='uplabel'>
                <label> Charger le Document : </label>
                <input type="file" onChange={handleFileChange} />
            </div>
            <button className='download-button' onClick={handleFileUpload}>Upload</button>
            {/* <SearchFile/> */}
            <p>{uploadStatus}</p>
            {downloadLink && (
                <p>
                Your file has been uploaded.{' '}
                <a href={downloadLink} target="_blank" rel="noopener noreferrer">
                    Click here to download.
                </a>
                </p>
            )}
        </div>
    </div>
  );
}

export default Upload;
